import { Card, Divider } from "antd";
import composedChart from "./chart";
import rowData from "./rowData";
import { IProgramReportResponse } from "../../../interfaces/reports-program.interface";
import { useDimensions } from "../../../hooks/useDimensions";

interface ProgramComponent {
  data?: IProgramReportResponse;
}

const ProgramCharts = ({ data }: ProgramComponent) => {
  const { width } = useDimensions();
  return (
    <>
      <div className="flex flex-1 flex-col">
        <Card
          style={{
            boxShadow:
              "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
            maxWidth: width <= 500 ? "25rem" : undefined,
          }}
        >
          <div
            className={`flex flex-1 justify-between`}
            style={{
              maxWidth: width <= 500 ? "25rem" : undefined,
              overflow: width <= 500 ? "auto" : undefined,
            }}
          >
            <div>
              <Divider orientation="left" plain>
                Courses by Code
              </Divider>
              {composedChart({
                type: "donut",
                key: "courseCode",
                data: data?.coursesByCode ?? [],
                config: {
                  dataKey: "total",
                  label: `Courses: ${data?.coursesByCode?.length}`,
                  legend: ["Code", "Courses", ""],
                  colorSet: 0,
                },
              })}
            </div>
            <div>
              <Divider orientation="left" plain>
                Total Students by Course Code
              </Divider>
              {composedChart({
                type: "donut",
                key: "courseCode",
                data: data?.totalByCourseCode ?? [],
                config: {
                  dataKey: "students",
                  legendKey: "payment",
                  label: `Students: ${data?.totalByCourseCode?.length}`,
                  legend: ["Code", "Students", "Paid"],
                  colorSet: 0,
                },
              })}
            </div>
          </div>
        </Card>
        <Card
          className="mt-8"
          style={{
            boxShadow:
              "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
            maxWidth: width <= 500 ? "25rem" : undefined,
          }}
        >
          <div
            className="flex-1"
            style={{
              maxWidth: width <= 500 ? "25rem" : undefined,
              overflow: "auto",
            }}
          >
            <Divider orientation="left" plain className="pb-4">
              Total Students by Registration type
            </Divider>
            {composedChart({
              type: "bar",
              key: "registrationType",
              data: sortData(data?.totalByRegistrationType ?? [], "year"),
              config: {
                xField: "year",
                yField: ["webcastAudit", "webcast", "audit", "inClass"],
                colorSet: 0,
              },
            })}
            {rowData(
              sortData(data?.totalByRegistrationType ?? [], "year"),
              "year",
              0,
            )}
          </div>
        </Card>
        <Card
          className="mt-8"
          style={{
            boxShadow:
              "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
            maxWidth: width <= 500 ? "25rem" : undefined,
          }}
        >
          <div
            className="flex-1"
            style={{
              maxWidth: width <= 500 ? "25rem" : undefined,
              overflow: "auto",
            }}
          >
            <Divider orientation="left" plain>
              Total passing students
            </Divider>
            {composedChart({
              type: "bar",
              key: "total",
              data: data?.totalPassingStudents ?? [],
              config: {
                xField: "date",
                yField: ["fail", "pending", "pass"],
                colorSet: 1,
              },
            })}
            {rowData(data?.totalPassingStudents ?? [], "date", 1)}
          </div>
        </Card>
        <Card
          className="mt-8"
          style={{
            boxShadow:
              "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
            maxWidth: width <= 500 ? "25rem" : undefined,
          }}
        >
          <div
            className="flex flex-1 gap-12 justify-between"
            style={{
              maxWidth: width <= 500 ? "25rem" : undefined,
              overflow: "auto",
            }}
          >
            <div className="flex-1">
              <Divider orientation="left" plain>
                Total registration per location
              </Divider>
              {composedChart({
                type: "radar",
                key: "total",
                data: data?.registrationPerLocation ?? [],
                config: {
                  xField: "location",
                  yField: "total",
                },
              })}
            </div>
            <div className="flex-1">
              <Divider orientation="left" plain>
                User accounts per type
              </Divider>
              <div className="ml-8">
                {composedChart({
                  type: "verticalBar",
                  key: "registrationType",
                  data: data?.userType ?? [],
                  config: {
                    xField: "userType",
                    yField: "total",
                  },
                })}
              </div>
            </div>
          </div>
        </Card>
      </div>
    </>
  );
};

const sortData = (data: any, key: string) => {
  return data.sort((a: any, b: any) => a[key] - b[key]);
};

export default ProgramCharts;
